import React from "react";
import { Button, Row, Col } from "reactstrap";
import { api } from "../../../Api/Api";
import { toast } from "react-toastify";


const EnableRenewModal = ({setIsEnable, userId, Refetch} : any) => {
  
  const handleRenewalClick = async () => {
    try {
      const response = await api.post(
        `/members/enable-renew-order/${userId}`,
        {},
        true
      );
      toast.success("Renewal Enabled", { toastId: "member_district_treasurer_verify" });
      setIsEnable(false)
      Refetch();
      console.log("Renewal successful", response);
    } catch (error) {
      console.error("Error enabling renewal", error);
    }
  };

  return (
       <div className="form-wrap">
               <Row className="gy-4">
                 <Col lg={12}>
                   <div className="modal-warning-text-wrap">
                     <div className="warning-img-wrap">
                       <img src="/images/delete-warning.svg" alt="warning-icon" />
                     </div>
                     <h5 className="modal-warning-title">Enable Membership Renew</h5>
                     <small className="sub-text">Do you really want to Enable Renewal.</small>
                   </div>
                 </Col>
       
                 <Col lg={12}>
                   <div className="submit-btn-wrap centered">
                     <Button
                       color={"danger"}
                       outline
                       className="sm"
                      onClick={() => setIsEnable(false)}
                     >
                       Cancel
                     </Button>
                     <Button color={"primary"} className="sm" onClick={handleRenewalClick}>
                       Enable
                     </Button>
                   </div>
                 </Col>
               </Row>
           </div>
   );
 };

export default EnableRenewModal;
